module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","addDays"],"commonjs":"date-fns/add_days/index","commonjs2":"date-fns/add_days/index","amd":"date-fns/add_days/index"}
// module id = 12
// module chunks = 0